import classNames from "classnames"
import React from "react"

import { Color } from "../../../constants/V2/color"
import { getTextColorClass } from "../../../utils/V2/color"

type StarProps = {
  fill: number
  color: Color
}

const RatingStar = ({ fill, color }: StarProps) => {
  return (
    <svg
      viewBox="0 0 16 15"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        "w-[12px] md:w-16 lg:w-20",
        getTextColorClass(color),
        {
          "opacity-50": fill === 0,
        }
      )}
    >
      {fill !== 0 && fill !== 100 && (
        <defs>
          <linearGradient
            id="partial-fill-gradient"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
          >
            <stop offset="0%" stopOpacity={1} stopColor="currentColor"></stop>
            <stop
              offset={`${fill}%`}
              stopOpacity={1}
              stopColor="currentColor"
            ></stop>
            <stop
              offset={`${fill}%`}
              stopOpacity={0.5}
              stopColor="currentColor"
            ></stop>
            <stop
              offset="100%"
              stopOpacity={0.5}
              stopColor="currentColor"
            ></stop>
          </linearGradient>
        </defs>
      )}

      <path
        d="M7.66787 0.745113C7.796 0.457663 8.204 0.457662 8.33213 0.745112L10.1247 4.76653C10.1775 4.88509 10.2896 4.96649 10.4186 4.98011L14.7972 5.44224C15.1101 5.47527 15.2362 5.86331 15.0024 6.07399L11.7318 9.0215C11.6354 9.10839 11.5926 9.2401 11.6195 9.36707L12.533 13.6741C12.5983 13.982 12.2682 14.2218 11.9956 14.0646L8.18168 11.8648C8.06924 11.7999 7.93076 11.7999 7.81832 11.8648L4.00439 14.0646C3.73177 14.2218 3.40168 13.982 3.46698 13.6741L4.38051 9.36707C4.40744 9.2401 4.36465 9.10839 4.26823 9.0215L0.997557 6.07399C0.76377 5.86331 0.889851 5.47527 1.20283 5.44224L5.58135 4.98011C5.71044 4.96649 5.82247 4.88509 5.87532 4.76653L7.66787 0.745113Z"
        fill={
          fill !== 0 && fill !== 100
            ? "url(#partial-fill-gradient)"
            : "currentColor"
        }
      />
    </svg>
  )
}

export default RatingStar
